// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24cqC","right":"styles_right__gMOY0"};